// utils/ProtectedRoute.tsx - Modified to redirect to marketing site
import React, { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { AuthUser } from '@/types';

interface ProtectedRouteProps {
    user: AuthUser | null | undefined;
    children: ReactNode;
}

export const ProtectedRoute = ({ user, children }: ProtectedRouteProps) => {
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

// Note: The original intent was to redirect unauthenticated visitors to /site/
// (the marketing site) in production, and to /login only in dev. This was changed
// to always redirect to /login because the /site/ redirect caused a "hall of mirrors"
// loop on logout. The marketing site redirect for first-time visitors should be
// handled at the nginx level (redirect / to /site/ unless a valid session cookie exists)
// or on the login page itself (show marketing content to non-returning users).
